import PropTypes from 'prop-types';
import styles from './FJImageToImageLeft.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import FJPromptInputContainer from '../FJPromptInput/FJPromptInputContainer';
import FJGenerateQuantityContainer from '../FJGenerateQuantity/FJGenerateQuantityContainer';
import FJModalListContainer from '../FJModalList/FJModalListContainer';
import FJGenerateButton from '../../../common/components/FJGenerateButton/FJGenerateButton';
import FJAppLeft from '../../FJMainPreview/FJAppLeft/FJAppLeft';

const FJImageToImageLeft = props => {
    const { generateQuantity, onGenerate, taskStatus, isProjectLoading, freeNumCreation, creditNumber } = props;
    const useCredit = generateQuantity * 2;
    const isFree = freeNumCreation > 0 && generateQuantity * 2 > creditNumber && generateQuantity < 3;
    return (
        <FJAppLeft className={styles.container}>
            <FJPromptInputContainer />
            <div className={styles.line} style={{ marginTop: '21px' }}></div>
            <div className={styles.style_title}>{FJLocalStore._('style')}</div>
            <FJModalListContainer />
            <div className={styles.footer}>
                <FJGenerateQuantityContainer />
                <FJGenerateButton
                    onClick={onGenerate}
                    taskStatus={taskStatus}
                    freeNumCreation={freeNumCreation}
                    isFree={isFree}
                    useCredit={useCredit}
                    isProjectLoading={isProjectLoading}
                />
            </div>
        </FJAppLeft>
    );
};
export default FJImageToImageLeft;
FJImageToImageLeft.propTypes = {
    generateQuantity: PropTypes.number,
    onGenerate: PropTypes.func,
    taskStatus: PropTypes.string,
    freeNumCreation: PropTypes.number,
    creditNumber: PropTypes.number,
    isProjectLoading: PropTypes.bool,
};
